import React, { Component } from 'react';
import {
  node,
  oneOfType,
  arrayOf,
  shape,
} from 'prop-types';
import { withRouter } from 'react-router';
import { Object } from 'es6-shim';
import {getRuntimeEnvVariables} from "../helpers/Utils";

// Create new context
export const ApplicationConfig = React.createContext();

// Then create a Provider Component
class ApplicationConfigProvider extends Component {
  static propTypes = {
    appConfig: shape({}).isRequired,
    match: shape({}).isRequired,
    children: oneOfType([
      arrayOf(node),
      node,
    ]).isRequired,
  };

  constructor(props) {
    super(props);
    this.getConfig = this.getConfig.bind(this);
  }

  getCountryWithIso(countries, iso) {
    if (getRuntimeEnvVariables('RUNTIME_ENABLE_INTERNATIONAL_WATERS') !== 'true' && countries)
      return countries.findIndex(country => country.iso === iso);

    return -1;
  }

  getConfig(key) {
    const { appConfig } = this.props;
    const defaultLanguage = appConfig?.languages?.defaultLanguage;
    const localisation = appConfig?.languages?.localisation;
    const { match: { params } } = this.props;
    const language = params?.language && /^[a-zA-Z]{2,3}(?:-[A-Z]{2,3}(?:-[a-zA-Z]{4})?)?$/.test(params.language) && localisation[params.language.toLowerCase()] ? params.language.toLowerCase() : defaultLanguage;

    let value = key.split('.').reduce((a, b) => a[b], appConfig);
    if (!value) return '';
    if (value[language]) {
      value = value[language];
    }
    if (key === 'optionKeys') {
      const keys = Object.keys(value);
      value = Object.assign(...Object.entries(value).map(([k]) => (value[k].options[language]))
        .map((item, index) => ({ [keys[index]]: item })));

      const internationalWaterCountryIdx = this.getCountryWithIso(value.countryOptions.entries, 'XZ');
      if (internationalWaterCountryIdx > -1)
        value.countryOptions.entries.splice(internationalWaterCountryIdx, 1);

    } else if (key === 'ti-funnel') {
      const internationalWaterCountryIdx = this.getCountryWithIso(value.featuredDestinationSuggestions, 'XZ');
      if (internationalWaterCountryIdx > -1)
        value.featuredDestinationSuggestions.splice(internationalWaterCountryIdx, 1);

    }
    return { ...value, language, localisation };
  }

  render() {
    const { children } = this.props;
    const value = {
      getConfig: this.getConfig,
    };

    return (
      <ApplicationConfig.Provider value={value}>
          {children}
        </ApplicationConfig.Provider>
    );
  }
}

export default withRouter(ApplicationConfigProvider);
